function Accordion() {
  return {
    tab: '',
    updateTab(data, dispatch) {
      dispatch('tab-changed', data);
      this.tab = data.tabId;
    },
    init(activeTab) {
      this.tab = activeTab;
    },
  };
}

export default Accordion;
